import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

@Component({
  templateUrl: './offline-edit-version-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    NgbTooltipModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ]
})
export class OfflineEditVersionModalComponent {
  public readonly alertType = MbsPopupType;

  @ViewChild(ModalComponent, { static: true }) modal: ModalComponent;

  constructor() {}

  handleClose() {
    this.modal.close();
  }
}
